import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import SubSection from "../SubSection";
import Section from "../Section";
import { UIPortal } from "@solidwhite/ui-portal";
import { HVAC } from "./HVAC";
import { Infrastructure } from "./Infrastructure";
import { Automotive } from "./Automotive";
import { RenewableEnergy } from "./RenewableEnergy";

import HeatingIndustriesApplicationsUI from "../../ui/Sections/Industries/HeatingIndustriesApplicationsUI";

const HeatingIndustries = ({ nodes }) => {
  return (
    <Ebbne id="industries">
      <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
        <Section object3d={nodes.industries} />
      </group>

      <Ebbne id="HVAC" visibleWithAbove={2}>
        <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
          <SubSection object3d={nodes.HVAC} />
        </group>

        <MountWithEbbne>
          <HVAC />

          <UIPortal>
            <HeatingIndustriesApplicationsUI key="hvac_applications" industryId="HVAC" />
          </UIPortal>
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="infrastructure" visibleWithAbove={2}>
        <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
          <SubSection object3d={nodes.infrastructure} />
        </group>

        <MountWithEbbne>
          <Infrastructure />

          <UIPortal>
            <HeatingIndustriesApplicationsUI key="infrastructure_applications" industryId="infrastructure" />
          </UIPortal>
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="Automotive" visibleWithAbove={2}>
        <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
          <SubSection object3d={nodes.Automotive} />
        </group>

        <MountWithEbbne>
          <Automotive />

          <UIPortal>
            <HeatingIndustriesApplicationsUI key="automotive_applications" industryId="Automotive" />
          </UIPortal>
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="RenewableEnergy" visibleWithAbove={2}>
        <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
          <SubSection object3d={nodes.RenewableEnergy} />
        </group>

        <MountWithEbbne>
          <RenewableEnergy />

          <UIPortal>
            <HeatingIndustriesApplicationsUI key="renewableenergy_applications" industryId="RenewableEnergy" />
          </UIPortal>
        </MountWithEbbne>
      </Ebbne>
    </Ebbne>
  );
};

export default HeatingIndustries;
